import styled from 'styled-components'

export const WrapperTableBody = styled.div`
  display: flex;
`

export const WrapperTableRow = styled.div`
  flex: 1;
`

export const TDSubtable = styled.td`
  width: 75%;
`

export const SubTableRow = styled.tr`
  display: flex;
  justify-content: flex-end;
`

export const Title = styled.h2`
  text-align: center;
  margin: 40px 0 5px 0;
`
